import { AnalyticsFieldSearchResponseSchema, AnalyticsFieldSearchSchema, } from '../analytics/fields.js';
import { FlowAnalyticsQuerySchema } from '../analytics/flow.js';
import { OmniFilterSchema } from '../analytics/omni/filters.js';
import { AnalyticsQueryResponseSchema } from '../analytics/query.js';
import { AssistantChatMessageSchema, AssistantChatSessionListItemSchema, AssistantChatSessionListResponseSchema, AssistantVoiceCallConversationSchema, } from '../assistant/chatSession.js';
import { AssistantDefinitionSchema } from '../assistant/definition.js';
import { AssistantListResponseSchema, AssistantSchema } from '../assistant/read.js';
import { AssistantToolDefinitionSchema } from '../assistant/tool.js';
import { AssistantVoiceCallSchema } from '../assistant/voiceCall.js';
import { ConnectionSchema } from '../connection/connection.js';
import { FeedExpectedSourceFieldsSchema, FeedSchema } from '../feed/read.js';
import { NotificationContentListResponseSchema, NotificationContentSchema, } from '../notification/content.js';
import { NotificationIntentSchema } from '../notification/intent.js';
import { NotificationScheduleWithTimingsSchema } from '../notification/schedule.js';
import { NotificationSchemeFullSchema, NotificationSchemeListResponseSchema, } from '../notification/scheme.js';
import { OrganizationReadResponseSchema, OrganizationSchema } from '../organization/read.js';
import { PrevisitFormSetListResponseSchema, PrevisitFormSetSchema, PrevisitFormSummarySchema, } from '../previsitForm/setResponse.js';
import { PrevisitFormTemplateSchema } from '../previsitForm/templateResponse.js';
import { ScenarioSchema } from '../scenario/read.js';
/**
 * The schemas primary names in its published surface, keyed by that name.
 *
 * A client that knows a name can reach the schema behind it directly, rather than pulling a
 * component out of a generated document. Naming them in one place is what keeps the two the same
 * thing.
 *
 * Matching the routes published alongside them.
 */
export const PRIMARY_API_SCHEMAS_BY_NAME = {
    AnalyticsFieldSearch: AnalyticsFieldSearchSchema,
    AnalyticsFieldSearchResponse: AnalyticsFieldSearchResponseSchema,
    AnalyticsQueryResponse: AnalyticsQueryResponseSchema,
    Assistant: AssistantSchema,
    AssistantChatMessage: AssistantChatMessageSchema,
    AssistantChatSessionListItem: AssistantChatSessionListItemSchema,
    AssistantChatSessionListResponse: AssistantChatSessionListResponseSchema,
    AssistantDefinition: AssistantDefinitionSchema,
    AssistantListResponse: AssistantListResponseSchema,
    AssistantToolDefinition: AssistantToolDefinitionSchema,
    AssistantVoiceCall: AssistantVoiceCallSchema,
    AssistantVoiceCallConversation: AssistantVoiceCallConversationSchema,
    Connection: ConnectionSchema,
    Feed: FeedSchema,
    FeedExpectedSourceFields: FeedExpectedSourceFieldsSchema,
    FlowAnalyticsQuery: FlowAnalyticsQuerySchema,
    JsonValue: AnalyticsQueryResponseSchema.shape.rows.element.valueType,
    OmniFilter: OmniFilterSchema,
    NotificationContent: NotificationContentSchema,
    NotificationContentListResponse: NotificationContentListResponseSchema,
    NotificationIntent: NotificationIntentSchema,
    NotificationSchedule: NotificationScheduleWithTimingsSchema,
    NotificationScheme: NotificationSchemeFullSchema,
    NotificationSchemeListResponse: NotificationSchemeListResponseSchema,
    Organization: OrganizationSchema,
    OrganizationReadResponse: OrganizationReadResponseSchema,
    PrevisitFormSet: PrevisitFormSetSchema,
    PrevisitFormSetListResponse: PrevisitFormSetListResponseSchema,
    PrevisitFormSummary: PrevisitFormSummarySchema,
    PrevisitFormTemplate: PrevisitFormTemplateSchema,
    Scenario: ScenarioSchema,
};
//# sourceMappingURL=schemas.js.map